import { AuthService } from './../models/auth.service';
import { LANG_NL_TRANS } from './../translate/lang-nl';
import { LANG_EN_TRANS } from './../translate/lang-en';
import { LANG_DE_TRANS } from './../translate/lang-de';
import { LANG_PT_TRANS } from './../translate/lang-pt';
import { LANG_FR_TRANS } from './../translate/lang-fr';
import { LANG_PL_TRANS } from './../translate/lang-pl';

import { Component, OnInit } from '@angular/core';

declare var window: any;
@Component({
  selector: 'wego-language-api-helper',
  styles: [`
    .wrap-language{
      padding: 15px;  
    }
    .list-group-item{
      padding: 5px 15px;
    }
  `],
  template: `
          <div class="wrap-language">
            <header>
              <h1 class="text-center">Language API File</h1>
            </header>
            <article>
              <div class="row">
                <section class="col-sm-6" *ngIf="missingInENArray && missingInENArray.length > 0">
                  <header>
                    <h4>Missing in English Label</h4>
                  </header>
                  <ul class="list-group">
                    <li class="list-group-item" *ngFor="let item of missingInENArray">{{ item }}</li>
                  </ul>
                </section>
                <section class="col-sm-6" *ngIf="missingInNLArray && missingInNLArray.length > 0">
                  <header>
                    <h4>Missing in Dutch Label</h4>
                  </header>
                  <ul class="list-group">
                    <li class="list-group-item" *ngFor="let item of missingInNLArray">{{ item }}</li>
                  </ul>
                </section>
                <section class="col-sm-6" *ngIf="missingInDEArray && missingInDEArray.length > 0">
                  <header>
                    <h4>Missing in German Label</h4>
                  </header>
                  <ul class="list-group">
                    <li class="list-group-item" *ngFor="let item of missingInDEArray">{{ item }}</li>
                  </ul>
                </section>
              </div>
              <div class="row">
                <section class="col-sm-6" *ngIf="missingInDEArray && missingInDEArray.length > 0">
                <header>
                  <h4>Missing in Lbl Label</h4>
                </header>
                <ul class="list-group">
                  <li class="list-group-item" *ngFor="let item of missingInDEArray">{{ item }}</li>
                </ul>
              </section>
              </div>
              <div class="row">
                <section class="col-sm-6" *ngIf="missingInPTArray && missingInPTArray.length > 0">
                <header>
                  <h4>Missing in Portuguese Label</h4>
                </header>
                <ul class="list-group">
                  <li class="list-group-item" *ngFor="let item of missingInPTArray">{{ item }}</li>
                </ul>
              </section>
              </div>
              <div class="row">
                <section class="col-sm-6" *ngIf="missingInFRArray && missingInFRArray.length > 0">
                <header>
                  <h4>Missing in French Label</h4>
                </header>
                <ul class="list-group">
                  <li class="list-group-item" *ngFor="let item of missingInFRArray">{{ item }}</li>
                </ul>
              </section>
              </div>
              <div class="row">
                <section class="col-sm-6" *ngIf="missingInPLArray && missingInPLArray.length > 0">
                <header>
                  <h4>Missing in Polish Label</h4>
                </header>
                <ul class="list-group">
                  <li class="list-group-item" *ngFor="let item of missingInPLArray">{{ item }}</li>
                </ul>
              </section>
              </div>
              <div class="clearfix"></div>
              <section>
                <header>
                  <h4>Old Key Values</h4>
                </header>
            
                <input type="file" id="csvFileInput" (change)="HandleFiles($event.target.files)" accept=".csv">
              </section>
              <section>
                <header>
                  <h4>System Labels</h4>
                </header>
                <div class="row">
                  <div class="col-sm-6">
                    <label class="radio-inline"><input type="radio" [(ngModel)]="onlyNewKeys" name="onlyNewKeys" [value]="true">Only New Label</label>
                    <label class="radio-inline"><input type="radio" [(ngModel)]="onlyNewKeys" name="onlyNewKeys" [value]="false">All Label</label>
                  </div>
                  <div class="col-sm-6 text-right">
                    <button class="btn btn-success btn-xs" type="button" (click)="DownloadNewLabelCSV()">Download New Label</button>&nbsp;&nbsp;
                    <button class="btn btn-info btn-xs" type="button" (click)="DownloadAllLabelCSV()">Download All Label</button>
                  </div>
                </div>
                <table class="table table-bordered">
                  <tr>
                    <th>Key</th>
                    <th>English Old</th>
                    <th>English New</th>
                    <th>Dutch Old</th>
                    <th>Dutch New</th>
                    <th>Germany Old</th>
                    <th>Germany New</th>
                    <th>Portuguese Old</th>
                    <th>Portuguese New</th>
                    <th>French Old</th>
                    <th>French New</th>
                    <th>Polish Old</th>
                    <th>Polish New</th>                                        
                  </tr>
                  <tr *ngFor="let item of combineArray" [ngClass]="{'hide': DisplayNewOnly(item) }">
                    <td [ngClass]="{'success' : ExistInOld(item.key) }">{{ item.key }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.en_old, item.en) }">{{ item.en_old }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.en_old, item.en) }">{{ item.en }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.nl_old, item.nl) }">{{ item.nl_old }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.nl_old, item.nl) }">{{ item.nl }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.de_old, item.de) }">{{ item.de_old }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.de_old, item.de) }">{{ item.de }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.pt_old, item.pt) }">{{ item.pt_old }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.pt_old, item.pt) }">{{ item.pt }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.fr_old, item.fr) }">{{ item.fr_old }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.fr_old, item.fr) }">{{ item.fr }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.pl_old, item.pl) }">{{ item.pl_old }}</td>
                    <td [ngClass]="{'danger' : MatchValue(item.pl_old, item.pl) }">{{ item.pl }}</td>
                  </tr>
                </table>
              </section>
            </article>
          </div>
  `
})
export class LanguageHelperAPIComponent implements OnInit {
  missingInPtArray: any;
  missingInNLArray: any;
  missingInDEArray: any;
  missingInENArray: any;
  missingInPTArray: any;
  missingInFRArray: any;
  missingInPLArray: any;

  mapArray: any;
  oldArray: any;
  combineArray: any = [];
  //oldKeys: any;
  onlyNewKeys: boolean = false;
  en: any;
  nl: any;
  de: any;
  pt: any;
  fr: any;
  pl: any;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.GetEnglishLabel();
  }

  public GetEnglishLabel() {
    this.authService.GetResourceLabel("en").subscribe(
      (res: any) => {
        this.en = res.data;
        this.GetDutchLabel();
      },
      (error: any) => {
        console.log(error);
      });
  }

  public GetDutchLabel() {
    this.authService.GetResourceLabel("nl").subscribe(
      (res: any) => {
        this.nl = res.data;
        this.GetDeLabels();
      },
      (error: any) => {
        console.log(error);
      });
  }

  public GetDeLabels() {
    this.authService.GetResourceLabel("de").subscribe(
      (res: any) => {
        this.de = res.data;
        this.Init();
        // this.GetDutchLabel();
      },
      (error: any) => {
        console.log(error);
      });
  }

  public GetPtLabels() {
    this.authService.GetResourceLabel("pt").subscribe(
      (res: any) => {
        this.pt = res.data;
        this.Init();
      },
      (error: any) => {
        console.log(error);
      });
  }

  public GetFrLabels() {
    this.authService.GetResourceLabel("fr").subscribe(
      (res: any) => {
        this.fr = res.data;
        this.Init();
      },
      (error: any) => {
        console.log(error);
      });
  }

  public GetPlLabels() {
    this.authService.GetResourceLabel("pl").subscribe(
      (res: any) => {
        this.pl = res.data;
        this.Init();
      },
      (error: any) => {
        console.log(error);
      });
  }  

  public Init() {
    let en = this.en;
    let nl = this.nl;
    let de = this.de;
    let pt = this.pt;
    let fr = this.fr;
    let pl = this.pl;
    // let pt = this.pt;

    let enKeys = Object.keys(en);
    let nlKeys = Object.keys(nl);
    let deKeys = Object.keys(de);
    let ptKeys = Object.keys(pt);
    let frKeys = Object.keys(fr);
    let plKeys = Object.keys(pl);
    // let ptKeys = Object.keys(pt);

    this.missingInNLArray = this.MissingKeys(enKeys, nlKeys);
    console.log(this.missingInNLArray);

    this.missingInENArray = this.MissingKeys(nlKeys, enKeys);
    console.log(this.missingInENArray);

    this.missingInDEArray = this.MissingKeys(enKeys, deKeys);
    console.log(this.missingInDEArray);

    this.missingInPtArray = this.MissingKeys(enKeys, ptKeys);
    console.log(this.missingInPtArray);

    this.missingInFRArray = this.MissingKeys(enKeys, frKeys);
    console.log(this.missingInFRArray);

    this.missingInPLArray = this.MissingKeys(enKeys, plKeys);
    console.log(this.missingInPLArray);

    let matchKeys = enKeys;
    matchKeys = matchKeys.concat(this.missingInENArray);


    // this.missingInPTArray = this.MissingKeys(matchKeys, ptKeys);
    // console.log(this.missingInPTArray);

    this.mapArray = this.MapArray(matchKeys, en, nl, de, pt, fr, pl);
    console.log(this.mapArray);
  }

  public MissingKeys(array1: any, array2: any) {
    let missingArray: any = [];
    array1.forEach((element: any) => {
      if (!(array2.indexOf(element) > -1)) {
        missingArray.push(element);
      }
    });

    return missingArray;
  }

  public MapArray(keys: any, enArray: any, nlArray: any, deArray: any, ptArray: any, frArray: any, plArray: any) {
    var mapArray: any = [];

    keys.forEach((element: any) => {
      var mapObject = {};

      mapObject["key"] = element;

      mapObject["en"] = enArray[element];
      mapObject["nl"] = nlArray[element];
      mapObject["de"] = deArray[element];
      mapObject["pt"] = ptArray[element];
      mapObject["fr"] = frArray[element];
      mapObject["pl"] = plArray[element];

      mapArray.push(mapObject);
    });

    return mapArray;
  }

  public DownloadAllLabelCSV() {
    this.JSONToCSVConvertor(this.mapArray, "Language_BackOffice", true);
  }

  public DownloadNewLabelCSV() {
    let newMapArray = this.mapArray.filter((x: any) => this.ExistInOld(x.key));
    this.JSONToCSVConvertor(newMapArray, "Language_BackOffice", true);
  }

  public JSONToCSVConvertor(JSONData: any, ReportTitle: any, ShowLabel: any) {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

    var CSV = '';
    //Set Report title in first row or line

    //CSV += ReportTitle + '\r\n\n';

    //This condition will generate the Label/Header
    if (ShowLabel) {
      var row = "";

      //This loop will extract the label from 1st index of on array
      for (var index in arrData[0]) {

        //Now convert each value to string and comma-seprated
        row += index + ',';
      }

      row = row.slice(0, -1);

      //append Label row with line break
      CSV += row + '\r\n';
    }

    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
      var row = "";

      //2nd loop will extract each column and convert it in string comma-seprated
      for (var index in arrData[i]) {
        row += '"' + arrData[i][index] + '",';
      }

      row.slice(0, row.length - 1);

      //add a line break after each row
      CSV += row + '\r\n';
    }

    if (CSV == '') {
      alert("Invalid data");
      return;
    }

    //Generate a file name
    var fileName = "File_";
    //this will remove the blank-spaces from the title and replace it with an underscore
    fileName += ReportTitle.replace(/ /g, "_");

    //Initialize file format you want csv or xls
    var uri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(CSV);

    // Now the little tricky part.
    // you can use either>> window.open(uri);
    // but this will not work in some browsers
    // or you will not get the correct file extension    

    //this trick will generate a temp a /> tag
    let link: any = document.createElement("a");
    link.href = uri;

    //set the visibility hidden so it will not effect on your web-layout
    link.style = "visibility:hidden";
    link.download = fileName + ".csv";

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  public DisplayNewOnly(item: any) {
    if (this.onlyNewKeys) {
      return !this.ExistInOld(item.key) && !this.MatchValue(item.en_old, item.en) && !this.MatchValue(item.nl_old, item.nl) && !this.MatchValue(item.de_old, item.de) && !this.MatchValue(item.pt_old, item.pt) && !this.MatchValue(item.fr_old, item.fr) && !this.MatchValue(item.pl_old, item.pl);
    }
    else {
      return false;
    }
  }

  public ExistInOld(key: string) {
    if (this.oldArray) {
      //let oldKeyArray = this.oldKeys.split("\n");
      let oldKeyArray = this.oldArray.map((x: any) => x.key);

      if (!(oldKeyArray.indexOf(key) > -1))
        return true;
      else
        return false;
    }
    else {
      return true;
    }
  }

  public MatchValue(value1: string, value2: string) {
    if (value1 == value2)
      return false;
    else
      return true;
  }

  public HandleFiles(files: FileList) {
    // Check for the various File API support.
    if (window.FileReader) {
      // FileReader are supported.

      if (files && files.length > 0) {
        let file: File = files.item(0);
        //Now you can get
        console.log(file.name);
        console.log(file.size);
        console.log(file.type);
        this.GetAsText(file);
      }

    } else {
      alert('FileReader are not supported in this browser.');
    }
  }

  public GetAsText(fileToRead: any) {
    let reader = new FileReader();
    // Read file into memory as UTF-8      
    reader.readAsText(fileToRead);
    // Handle errors load
    reader.onload = (event) => this.LoadHandler(event);
    reader.onerror = (event) => this.ErrorHandler(event);
  }

  public LoadHandler(event: any) {
    let csv = event.target.result;
    this.oldArray = this.CSV2JSON(csv);
    this.combineArray = this.JoinObjects([this.mapArray, this.oldArray]);
    console.log(this.combineArray);
  }

  public CSVToArray(strData: string, strDelimiter?: string) {
    // Check to see if the delimiter is defined. If not,
    // then default to comma.
    strDelimiter = (strDelimiter || ",");
    // Create a regular expression to parse the CSV values.
    let objPattern = new RegExp((
      // Delimiters.
      "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
      // Quoted fields.
      "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
      // Standard fields.
      "([^\"\\" + strDelimiter + "\\r\\n]*))"), "gi");
    // Create an array to hold our data. Give the array
    // a default empty first row.
    let arrData: any = [[]];
    // Create an array to hold our individual pattern
    // matching groups.
    let arrMatches: any = null;
    // Keep looping over the regular expression matches
    // until we can no longer find a match.
    while (arrMatches = objPattern.exec(strData)) {
      // Get the delimiter that was found.
      let strMatchedDelimiter = arrMatches[1];
      // Check to see if the given delimiter has a length
      // (is not the start of string) and if it matches
      // field delimiter. If id does not, then we know
      // that this delimiter is a row delimiter.
      if (strMatchedDelimiter.length && (strMatchedDelimiter != strDelimiter)) {
        // Since we have reached a new row of data,
        // add an empty row to our data array.
        arrData.push([]);
      }
      // Now that we have our delimiter out of the way,
      // let's check to see which kind of value we
      // captured (quoted or unquoted).
      if (arrMatches[2]) {
        // We found a quoted value. When we capture
        // this value, unescape any double quotes.
        var strMatchedValue = arrMatches[2].replace(
          new RegExp("\"\"", "g"), "\"");
      } else {
        // We found a non-quoted value.
        var strMatchedValue = arrMatches[3];
      }
      // Now that we have our value string, let's add
      // it to the data array.
      arrData[arrData.length - 1].push(strMatchedValue);
    }
    // Return the parsed data.
    return (arrData);
  }

  public CSV2JSON(csv: string) {
    let array: any = this.CSVToArray(csv);
    let objArray: any = [];
    for (var i = 1; i < array.length; i++) {
      objArray[i - 1] = {};
      for (var k = 0; k < array[0].length && k < array[i].length; k++) {
        var key = array[0][k];
        objArray[i - 1][key] = array[i][k]
      }
    }

    // let json: any = JSON.stringify(objArray);
    // let str: any = json.replace(/},/g, "},\r\n");

    return objArray;
  }

  public ErrorHandler(evt: any) {
    if (evt.target.error.name == "NotReadableError") {
      alert("Can't read file !");
    }
  }

  public JoinObjects(magicArray: any) {
    var idMap = {};
    // Iterate over arguments
    for (var i = 0; i < magicArray.length; i++) {
      // Iterate over individual argument arrays (aka json1, json2)
      for (var j = 0; j < magicArray[i].length; j++) {
        var currentID = magicArray[i][j]['key'];
        if (!idMap[currentID]) {
          idMap[currentID] = {};
        }
        // Iterate over properties of objects in arrays (aka id, name, etc.)
        for (var key in magicArray[i][j]) {
          idMap[currentID][key] = magicArray[i][j][key];
        }
      }
    }

    // push properties of idMap into an array
    var newArray: any = [];
    for (var property in idMap) {
      newArray.push(idMap[property]);
    }
    return newArray;
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/language-herlper-api.component.ts